/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { StudentDto } from '../models/student-dto';
import { GrupaDziekanskaDto } from '../models/grupa-dziekanska-dto';
import { RejestracjaStudentaForm } from '../models/rejestracja-studenta-form';

/**
 * Studia Publiczne Controller
 */
@Injectable({
  providedIn: 'root',
})
class StudiaPubliczneControllerService extends __BaseService {
  static readonly aktywujKontoStudentaUsingPOSTPath = '/studia/publiczne/aktywuj-konto';
  static readonly getGrupyDziekanskieUsingGET2Path = '/studia/publiczne/grupy-dziekanskie/hash/{hash}';
  static readonly sprawdzCzyDopisacDoGrupyUsingPOSTPath = '/studia/publiczne/grupy-dziekanskie/hash/{hash}';
  static readonly zarejestrujStudentaUsingPOSTPath = '/studia/publiczne/zarejestruj';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * aktywujKontoStudenta
   * @param token token
   * @return OK
   */
  aktywujKontoStudentaUsingPOSTResponse(token: string): __Observable<__StrictHttpResponse<StudentDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = token;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/studia/publiczne/aktywuj-konto`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StudentDto>;
      })
    );
  }
  /**
   * aktywujKontoStudenta
   * @param token token
   * @return OK
   */
  aktywujKontoStudentaUsingPOST(token: string): __Observable<StudentDto> {
    return this.aktywujKontoStudentaUsingPOSTResponse(token).pipe(
      __map(_r => _r.body as StudentDto)
    );
  }

  /**
   * getGrupyDziekanskie
   * @param hash hash
   * @return OK
   */
  getGrupyDziekanskieUsingGET2Response(hash: string): __Observable<__StrictHttpResponse<GrupaDziekanskaDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/studia/publiczne/grupy-dziekanskie/hash/${encodeURIComponent(hash)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GrupaDziekanskaDto>;
      })
    );
  }
  /**
   * getGrupyDziekanskie
   * @param hash hash
   * @return OK
   */
  getGrupyDziekanskieUsingGET2(hash: string): __Observable<GrupaDziekanskaDto> {
    return this.getGrupyDziekanskieUsingGET2Response(hash).pipe(
      __map(_r => _r.body as GrupaDziekanskaDto)
    );
  }

  /**
   * sprawdzCzyDopisacDoGrupy
   * @param hash hash
   * @return OK
   */
  sprawdzCzyDopisacDoGrupyUsingPOSTResponse(hash: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/studia/publiczne/grupy-dziekanskie/hash/${encodeURIComponent(hash)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * sprawdzCzyDopisacDoGrupy
   * @param hash hash
   * @return OK
   */
  sprawdzCzyDopisacDoGrupyUsingPOST(hash: string): __Observable<string> {
    return this.sprawdzCzyDopisacDoGrupyUsingPOSTResponse(hash).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * zarejestrujStudenta
   * @param form form
   * @return OK
   */
  zarejestrujStudentaUsingPOSTResponse(form: RejestracjaStudentaForm): __Observable<__StrictHttpResponse<StudentDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = form;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/studia/publiczne/zarejestruj`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StudentDto>;
      })
    );
  }
  /**
   * zarejestrujStudenta
   * @param form form
   * @return OK
   */
  zarejestrujStudentaUsingPOST(form: RejestracjaStudentaForm): __Observable<StudentDto> {
    return this.zarejestrujStudentaUsingPOSTResponse(form).pipe(
      __map(_r => _r.body as StudentDto)
    );
  }
}

module StudiaPubliczneControllerService {
}

export { StudiaPubliczneControllerService }
